<section class="page-container">
    <div class="container-fluid ptCustom">
        <div class="row mt-4 submitMemberNews">
            <div class="col-12">
                <div class="row justify-content-center">
                    <div class="col-md-6">
                        <div class="submitMemberNewsWrap mt-4">
                            <div class="row gx-5 submitMemberNewsForm">
                                <div class="col-12">
                                    <div class="mb-4">
                                        <label for="notesTo" class="form-label">Notes <a href="javascript:void(0);"
                                                class="formTooltip" placement="top"
                                                ngbTooltip="Please note which ad you are submitting from your membership benefits guide."><i
                                                    class="fa-solid fa-circle-question"></i></a></label>
                                        <input [(ngModel)]="memberNotes" name="memberNotes" type="text"
                                            class="form-control" id="notesTo" placeholder="Notes" value="">
                                    </div>
                                    <div class="mb-4">
                                        <label for="url" class="form-label">Ad Url</label>
                                        <input [(ngModel)]="adUrl" name="adUrl" type="text" class="form-control"
                                            id="notesTo" placeholder="Notes" value="">
                                    </div>
                                    <div class="mb-4">
                                        <label for="adSize" class="form-label fs-3">Ad Size</label>
                                        <select class="form-select" aria-label="adSize" id="adSize"
                                            [(ngModel)]="adSize">
                                            <option *ngFor="let size of adType.sizeOptions" value="{{size}}">
                                                {{getSizeDisplay(size)}}</option>
                                        </select>
                                    </div>
                                    <div class="mb-4">
                                        <label for="runDate" class="form-label">Date To Run</label>
                                        <input [(ngModel)]="runDate" type="text" class="form-control"
                                            id="runDate" placeholder="mm/dd/yyyy">
                                        <div *ngIf="invalidRun">
                                            <i class="fas fa-exclamation-circle"></i> Date is invalid.
                                        </div>
                                    </div>
                                    <div *ngIf="adSize != null" class="mb-4">
                                        <label for="adImg" class="form-label">Advertisement Image <a
                                                href="javascript:void(0);" class="formTooltip" placement="top"
                                                ngbTooltip="All ads must be under 75KB
                                                Allowed file types: jpeg, jpg, png, webp
                                                Monday Morning Memo Ad: 728x90
                                                Member Story Ad: 880x620
                                                Member Directory Spotlight Ad: 600x560
                                                Annual Report Ad: 1050x600"><i
                                                    class="fa-solid fa-circle-question"></i></a></label>
                                        <input accept="image/*" (change)="updateAdImage($event.target.files)"
                                            class="form-control" type="file" id="adImg">
                                        <div *ngIf="adImage == null && submitPressed">
                                            <i class="fas fa-exclamation-circle"></i> Image is required.
                                        </div>
                                    </div>
                                    <div class="mb-4" *ngIf="adImage != null">
                                        <label for="articleImg" class="form-label">Ad Preview (not true to size)</label>
                                        <div class="imagePreview adPreview">
                                            <img [src]="preview" alt="ad preview" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 text-center mt-4">
                                    <button (click)="submitAd()" [disabled]="disabledSubmitButton" type="button"
                                        class="btn btn-secondary m-100 newsSubmitBtn">Submit Advertisement</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>